export default {
  token: false,
  loading: true,
  screenWidth: false,
  show_survey_commissions: false,
  statuses: [],
  suppliers: [],
};
